import logoLight from "./logo-light.svg"
import emblemLight from "./emblem-light.svg"

// Light-background brand lockup (dark wordmark + gold "AI" + petal emblem) and
// its standalone emblem. Used directly on light surfaces — no dark tile needed.
export const brand = { logoWord: logoLight, mark: emblemLight, emblem: emblemLight }
